import React, { Fragment, memo } from 'react';
import styled from 'styled-components';

import { times } from '@utils/array';

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

const SkeletonGroupHeader = styled.div`
  flex: 1;
  padding: 0.7rem 0.25rem;
  margin: 0.5rem 0.25rem 0 0.25rem;
  border: 1px solid ${({ theme }) => theme.colors.BORDER};
`;

const SkeletonGroupHeaderText = styled.div`
  height: 1.25rem;
  width: 100%;
  background-color: ${({ theme }) => theme.presets.SKELETON_VIEW};
`;

const SkeletonSlot = styled(SkeletonGroupHeader)`
  margin-top: 0;
  border-top: 0;
  padding: 0.55rem 0.25rem;
`;

const SkeletonSlotText = styled(SkeletonGroupHeaderText)`
  height: 0.9rem;
`;

function Skeleton() {
  return (
    <>
      {times(3).map((index) => (
        <Fragment key={index}>
          <Row>
            {times(7).map((headerIndex) => (
              <SkeletonGroupHeader key={`${index}:${headerIndex}`}>
                <SkeletonGroupHeaderText />
              </SkeletonGroupHeader>
            ))}
          </Row>
          {times(3).map((slotRowIndex) => (
            <Row key={`${index}:${slotRowIndex}`}>
              {times(7).map((slotIndex) => (
                <SkeletonSlot key={`${index}:${slotRowIndex}:${slotIndex}`}>
                  <SkeletonSlotText />
                </SkeletonSlot>
              ))}
            </Row>
          ))}
        </Fragment>
      ))}
    </>
  );
}
export default memo(Skeleton);
